import "./index.less";

export class Controller {
	constructor() {
		this.lookup.selection = false;
	}

	$onInit() {
		this.lookup.selection = this.lookup.state;
	}

	enableCustomInput() {
		this.lookup.selection = !this.lookup.selection;
		this.onSelect({
			lookup: this.lookup
		});
	}
}

export default angular
	.module("vesl.components.field-helpers.custom-input", [])
	.component("customInput", {
		template: `
			<button type="button"
				class="btn btn-default"
				uib-tooltip="{{$ctrl.lookup.selection ? 'Disable' : 'Enable'}} Custom Entry"
				ng-disabled="$ctrl.lookup.disabled"
				ng-click="$ctrl.enableCustomInput()">
				<i ng-class="$ctrl.lookup.selection ? 'c-red' : 'c-black'" class="zmdi zmdi-comment-text ma-icon"></i>
			</button>
    	`,
		controller: Controller,
		bindings: {
			lookup: "<",
			onSelect: "&"
		}
	}).name;
